import router from '@/router'
import store from '@/store'
import { COMMON } from '@/common'
import { Notify } from 'vant'
import { getToken } from '@/utils/cookie'
import i18n from '@/utils/lang'
// import qs from 'qs'

const whiteList = ['/getInto', '/login', '/setPassword', '/media', '/staff', '/guangzhou', '/Home', '/conferenceIntro', '/distribution', '/agenda', '/cooperation', '/setting', '/changePassword', '/video', '/health', '/promotionalVideo', '/arrangeSearch']
const whiteListJF = ['/payment', '/mediaSuccess']

router.beforeEach(async (to, from, next) => {
  document.title = getPageTitle(to.meta ? to.meta.title : '')
  const hasToken = getToken(to.params.conferenceId + to.params.type)
  const basePath = '/' + encodeURIComponent(to.params.conferenceId) + '/' + to.params.type
  const loginPath = basePath + '/login'
  // 如果是缴费嘉宾，没有登录，默认跳转填写信息页。
  if (to.params.type === 'JF') {
    if (whiteListJF.indexOf(to.path.replace(basePath, '')) !== -1) {
      next()
    } else {
      await store.dispatch('user/removeInfo')
      store.commit('user/SET_CONFERENCEID', to.params.conferenceId)
      store.commit('user/SET_TYPE', to.params.type)
      next(basePath + '/payment')
    }
    return
  }
  if (hasToken) {
    console.log('hasToken')
    if (to.path === loginPath) {
      next()
    } else {
      // 如果userId是空的，或者当前的大会id或身份和请求头中的不一致，则需要重新获取并更新vuex中的user的info
      // const hasInfo = store.getters.userId && store.getters.userId !== '' && store.getters.conferenceId === to.params.conferenceId && store.getters.type === to.params.type
      const hasInfo = false
      if (hasInfo) {
        next()
      } else {
        store.commit('user/SET_CONFERENCEID', to.params.conferenceId)
        store.commit('user/SET_TYPE', to.params.type)
        try {
          await store.dispatch('user/getInfo')
          // 如果（登录且跳转路径不是/login）身份是媒体记者或工作人员，且状态是审核中，且跳转路径不是/mediaConfirm，则跳转到/mediaConfirm
          const audit = ['MT', 'WK', 'GZ'].indexOf(store.getters.type) > -1 && store.getters.status === 'AUDIT' && whiteList.indexOf(to.path.replace(basePath, '')) === -1 && to.path.replace(basePath, '') !== '/mediaConfirm'
          if (audit) {
            next(basePath + '/mediaConfirm')
          } else {
            // console.log(to)
            next()
          }
        } catch (e) {
          await store.dispatch('user/resetToken')
          Notify({
            message: e || 'Has Error',
            type: 'danger'
          })
          next(`${loginPath}`) // ?redirect=${to.path}`)
        }
      }
    }
  } else {
    console.log('dont hasToken')
    await store.dispatch('user/removeInfo')
    store.commit('user/SET_CONFERENCEID', to.params.conferenceId)
    store.commit('user/SET_TYPE', to.params.type)
    if (whiteList.indexOf(to.path.replace(basePath, '')) !== -1) {
      console.log('next?')
      next()
    } else {
      next(`${loginPath}`) // ?redirect=${to.path}&` + qs.stringify(to.query))
    }
  }
})

const getPageTitle = function (pageTitle) {
  if (pageTitle) {
    return `${i18n.t(COMMON.TITLE)} - ${i18n.t(pageTitle)}`
  }
  return `${i18n.t(COMMON.TITLE)}`
}
